import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import * as $ from 'jquery';
import { CleverTapConstents, ConstantData } from 'src/app/services/constants';
import { DataService } from 'src/app/services/data.service';
import { EmpStatus, TosterMsgType } from 'src/app/services/model';
import { UtilService } from 'src/app/services/util.service';
import { ValidationService } from 'src/app/services/validation.service';

@Component({
  selector: 'app-student-details',
  templateUrl: './student-details.component.html',
  styleUrls: ['./student-details.component.scss']
})
export class StudentDetailsComponent implements OnInit, OnDestroy {

  sponsorConfirmPopup: boolean = false;
  guardianFlowPopup: boolean = false;
  date: Date | undefined;
  genderType = ConstantData.genderType;
  repayer = ConstantData.repayerData;
  isAdult: boolean = false;
  subscibtions: Subscription[] = [];

  boardTypeList:any;
  standardList:any[]=[];
  isSF:boolean=false;
  courseId:any;
  moratorium:boolean = false;
  fileUploaded: boolean = false;
  fileNameObj: any = {};
  fileIds:any;
  get isValidForm() {
    if(this.moratorium && !this.fileUploaded){
      return false;
    }
    // return !this.isAdult || this.formDetails.value.status === '3' || !this.isSF ? this.formDetails.controls['candidateName'].valid && this.formDetails.controls['candidateDOB'].valid && this.formDetails.controls['genderType'].valid : this.formDetails.valid;
     return this.isAdult || this.moratorium ? this.formDetails.valid : this.formDetails.controls['candidateName'].valid && this.formDetails.controls['candidateDOB'].valid && this.formDetails.controls['genderType'].valid ;

  }

  get empStatus(): EmpStatus[]{
    return this.util.empStatus || [];
  }


  get isParentFlow(){
    const is = !this.util.loanDetails?.isStudentMainApplicant && !this.util.loanDetails?.isSponser;
    return is; 
  }
  get isStudentFlow(){
    return (this.util.loanDetails?.hasMoratorium || this.util.loanDetails?.isCapacitaFlow) && this.util.loanDetails?.isStudentMainApplicant && !this.util.loanDetails?.isSponser;
  }
  today:Date = new Date();

  formDetails: any = new FormGroup({
    'candidateName': new FormControl('', [Validators.required]),
    'candidateDOB': new FormControl('', [Validators.required, this.validators.dateValidator.bind(this, false)]),
    'genderType': new FormControl('', [Validators.required]),
    'boardType' : new FormControl(''),
    'standards' : new FormControl(''),
    'repayer': new FormControl(this.repayer[1].value, [Validators.required]),
    'status': new FormControl('', [Validators.required]),
    'employmentststusofcandidate' : new FormControl({disabled: true,value: 'I have a job offer'}),
    'employerName': new FormControl({value: this.util.loanDetails?.institutionInfo.employerName,disabled: true}),
    'monthlyIncome': new FormControl(''),
    'attachmentId': new FormControl('')
  });

  constructor(public util: UtilService, private validators:ValidationService,public data:DataService,) { }

  ngOnInit(): void {
    this.util.getProducts().then(()=>{
    if(this.util.loanDetails?.hasMoratorium) {
      this.moratorium =true;
      this.formDetails.controls['status'].setValue('3'); 
      this.formDetails.controls['monthlyIncome'].addValidators(Validators.required);
      this.formDetails.controls['attachmentId'].addValidators(Validators.required);
     } else{
       this.moratorium  = false;
      }

      if(this.util.loanDetails?.isCapacitaFlow){
        this.formDetails.controls['status'].setValue('3'); 

      }
    this.isSF = this.util.loanDetails.productCategory == "EL_SF";
    this.isSF ? this.formDetails.controls['status'].setValue('3'):'';
    this.subscibtions.push(this.formDetails.controls['candidateDOB'].valueChanges.subscribe((value: any) => {
      console.log(value,this.util.getIsAdult(value));
     setTimeout(() => {
      this.isAdult =this.formDetails.controls['candidateDOB'].valid && this.util.getIsAdult(value);
      // !this.isAdult?  this.util.cleverTapEventCall(CleverTapConstents.minor_identified,{}):'';
     });
    }));
    
    this.isSF && this.getBoardname()
    this.fileNameObjCheck();
    })
 
    console.log(this.util.loanDetails)
  }
  fileNameObjCheck(uploadFilename?: string) {
    this.fileNameObj = {
      title: this.fileUploaded ? `Offer Letter` : `Upload the offer letter`,
      info: this.fileUploaded ? uploadFilename : `PDF Max size - 5MB`,
    };
  }


  openDrop(id: string) {
    $('#' + id).toggleClass('open').parent('.cus-dropdown').toggleClass('opened');
  }

  getEmpLabel(){
    return this.empStatus?.find((e)=> e.id ===  this.formDetails.controls['status'].value)?.status || '';
  }

  getGenderLabel(){
    return this.genderType.find((e)=> e.value ===  this.formDetails.controls['genderType'].value)?.label || '';
  }


  sponsorConfirm() {
    this.sponsorConfirmPopup = true;
    this.util.cleverTapEventCall(CleverTapConstents.sponser_select,{});
  }
  guardianFlowConfirm() {
    this.guardianFlowPopup = true;
  }

  getBoardType(board:any){
    const loanDetails = this.util.loanDetails;
    this.formDetails.controls['boardType'].setValue(board);
 
    this.util.handleRequests('get', this.util.getUrl('institute_data', [loanDetails.institutionId]),undefined,undefined,undefined,undefined,false).then((res)=>{
    //  console.log(CleverTapConstents.select_board);
    //   this.util.cleverTapEventCall(CleverTapConstents.select_board,{})
      for (let element of res.content.courses) {
        if (element.schoolBoard !== null && element.schoolBoard === board) {
          const item = {
            courseId: element.courseId,
            courseName: element.courseName,
          }
              this.standardList.push(item);
        }
    }
      
      });
  }
  setStandard(standard:any){
    this.formDetails.controls['standards'].setValue(standard.courseName);
    // console.log(CleverTapConstents.select_standard);
    // this.util.cleverTapEventCall(CleverTapConstents.select_standard,{})
    this.courseId = standard.courseId;
  }

  submit() {
    if (!this.isValidForm) {
      return;
    }
    const loanDetails = this.util.loanDetails;
    const fromValues = this.formDetails.getRawValue();
    let body:any = fromValues
   
      body = {
        ...fromValues,
        candidateDOB: this.util.formatDate(
          fromValues.candidateDOB,
          ConstantData.candidateDobFormate
        ),
        repayer: this.isSF ? 0 : !this.isAdult || fromValues.repayer === 0 ? 0 : 1,
        status: this.moratorium ? '3': this.isAdult ? fromValues.status : '3',
        courseId:this.courseId,
      };
      let cleverTapJson = {
        'candidateName':fromValues?.candidateName,
        'candidateDOB':fromValues?.candidateDOB,
        'genderType':fromValues?.genderType,
        'repayer':0,
        'attachmentId':fromValues?.attachmentId,
        'courseId':fromValues?.courseId,
        'coachingName':fromValues?.coachingName,
        'courseName':fromValues?.courseName,
         'loanId':this.util.loanDetails.loanId,
        'productCode':this.util.loanDetails.productCategory
      }
      // this.isAdult ? '':body.status === '3' ? this.util.cleverTapEventCall('Major Unemployed',{ loanId:this.util.loanDetails.loanId,
      //   productCode:this.util.loanDetails.productCode}):"";
      delete body['employmentststusofcandidate'];
      delete body['employerName'];
      if(!this.isAdult){
      this.util.cleverTapEventCall(CleverTapConstents.minor_identified,{})
      }
      if (loanDetails.hasMoratorium) {
      body['monthlyIncome']= body['monthlyIncome'].replaceAll(/,/gi,'');
      }else{
      delete body['attachmentId'];
      delete body['monthlyIncome']
      }
     
       this.util.handleRequests('put', this.util.getUrl('institute_candidateInfo', [loanDetails.loanId]), body).then((res:any)=>{
          this.util.getLoandetails().then(()=>{
            this.guardianFlowPopup = this.isParentFlow || this.isStudentFlow;
            this.guardianFlowPopup &&    setTimeout(() => {
              this.util.navigationHandler();
            }, ConstantData.popUpTimer * 1000);

            !this.guardianFlowPopup &&  this.util.navigationHandler();
            this.util.cleverTapEventCall(CleverTapConstents.fill_the_student_details,cleverTapJson);
          })
      });
      




  }

  gotoHome(){
    this.util.route('home');
  }
  ngOnDestroy(): void {
    this.subscibtions.forEach((res: Subscription) => {
      res.unsubscribe();
    });
  }

  getBoardname(){
    const loanDetails = this.util.loanDetails;
    let params = { "schoolName": "", "city": '', "state": '', "lat": '', "lng": '' };
    const base64Str = btoa(JSON.stringify(params));
    this.util.handleRequests('get', this.util.getUrl('school_filter', [base64Str])).then(res => {
      this.boardTypeList = res.content.allSchool.find( (e:any) => e.id === loanDetails?.institutionId )?.board_type;
      });
  };
  uploadDoc(event: any) {
    if (event) {
      this.util.loaderService.show();
      const uploadedForm = event.target.files[0];
      const formData = new FormData();
      formData.append('file', uploadedForm);
      this.util.handleRequests('put', this.util.getUrl('attachment_selfie'), formData, undefined, undefined, undefined, false).then((res: any) => {
        if(res.fileId){
          this.fileUploaded = true;
         this.fileIds = res.fileId;
         this.formDetails.patchValue({attachmentId:this.fileIds});
         this.fileNameObjCheck(res.fileName);
         this.util.loaderService.hide();
        }
         if (res['status'] === 'ERROR') {
           this.util.showToaster(res['content']['message'], TosterMsgType.ERROR);
           this.util.hideWaitingScreen();
           this.util.loaderService.hide();
         }
       }).catch(() => {
         this.util.hideWaitingScreen();
         this.util.loaderService.hide();
   
       });
    }
  }
  onlyNumber(evt: any) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  closeFile(offer:any){
    offer && (offer.value = '');
    this.fileUploaded = false;
    this.fileNameObjCheck();
    this.formDetails.controls['attachmentId'].reset(); //patchValue({attachmentId:''});
  }
}